import MAIN_VIEW_MODEL from '@/views/MAIN_VIEW_MODEL';
import { store } from '@/main';
import BusinessView from './Business/BusinessView';
import CostAllocationView from './Business/CostAllocation/CostAllocationView';
import PersonalView from './Personal/PersonalView';

const checkUserProfiles = (to, from, next) => {
  const getterName = `${MAIN_VIEW_MODEL.userAccount}/hasBusinnesProfile`;
  const hasBusinnesProfile = store.getters[getterName];

  next(hasBusinnesProfile || '/');
};

export default [{
  path: 'business-profile',
  name: 'Business profile',
  component: BusinessView,
  beforeEnter: checkUserProfiles,
  redirect: '/business-profile/cost-allocation',
  children: [
    {
      path: 'cost-allocation',
      name: 'Cost Allocation',
      component: CostAllocationView,
    },
  ],
},
{
  path: 'personal-profile',
  name: 'Personal profile',
  component: PersonalView,
  // TODO remove it when personal profile will be implement it
  redirect: '/',
},
];
